var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUudIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/uud_icon2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.98 17.966c.178.035.516.126.704.126 1.617 0 2.928-1.331 2.928-2.974 0-1.642-1.311-2.974-2.928-2.974l-.198.005m-14.732 0C3.218 12.242 2 13.535 2 15.12c0 1.642 1.31 2.973 2.928 2.973h.467m-.641-5.942L2 4.801l5.112.95L10.387 1l4.75 3.4 4.368-2.596-.019 10.345m-14.732 0c0 1.096.14 3.336.14 3.336.202 4.187 3.393 7.015 7.3 7.015 4.038 0 7.287-3.054 7.287-7.437l.005-2.914m-14.732 0L19.49 9.637M8.722 18.621c.879.753 2.075 1.206 3.378 1.206 2.128 0 4.005-1.219 4.622-3",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUudIcon2);
export default __webpack_public_path__ + "static/media/uud_icon2.b158b77d2e099d1ed9770d3a762ba6d9.svg";
export { ForwardRef as ReactComponent };